import React, { FC } from 'react';
import './DialogTitleWithSubtitle.less';
import { DialogTitleComponentProps } from '../DialogTitle';
import { DialogTitleRoot } from '../DialogTitleRoot';
import { DialogTitleText } from '../DialogTitleText';
import { DialogTitleActions } from '../DialogTitleActions';

interface IDialogTitleWithSubtitleProps extends DialogTitleComponentProps {
  onSearch?: (searchString: string) => void;
  subtitle?: string;
}

export const DialogWithSubtitle: FC<IDialogTitleWithSubtitleProps> = props => {
  return (
    <DialogTitleRoot className="dp-dialog-title-subtitle dp-dialog-title" {...props}>
      <DialogTitleText className="dp-dialog-title-subtitle__text" {...props}>
        <div className='dp-dialog-title-subtitle__resize-wrapper'>
          <span className="dp-dialog-title-subtitle__path" title={props.titleText}> {props.titleText?.replaceAll("/", " / ")} </span>
          {!!props.subtitle && (
            <>
              <span className="dp-dialog-title-subtitle__chevron" />
              <span className="dp-dialog-title-subtitle__path dp-dialog-title-subtitle__path--subtitle" title={props.subtitle}> {props.subtitle.replaceAll("/", " / ")} </span>
            </>
          )}
        </div>
      </DialogTitleText>
      <DialogTitleActions className="dp-dialog-title-subtitle__actions" {...props} />
    </DialogTitleRoot>
  );
};
